import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Route, type RouteProps } from 'react-router';

import { entityReset } from '@uncinc/react-drupal-core';

const CustomRoute: React.FC<RouteProps> = (props) => {
  const dispatch = useDispatch();

  // We may have done a request to translate-path for the current route.
  // Reset the entity to prevent a possible 404 page flash.
  useEffect(() => () => {
    dispatch(entityReset());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Route {...props} />
  );
};

export default CustomRoute;
